export const loadState = (key: string) => {
  try {
    const savedState = localStorage.getItem(key);
    if (savedState !== null) {
      return JSON.parse(savedState);
    }
  } catch (err) {
    return undefined;
  }
  return undefined;
};

export const saveState = (key: string, state: any): void => {
  try {
    const stateStr = JSON.stringify(state);
    localStorage.setItem(key, stateStr);
  } catch (err) {
    return;
  }
};



// WEBPACK FOOTER //
// ./src/store/localStorage.ts